<template>
  <div class="nav-module" :style="[wrapperStyle]">
    <div
      class="inner"
      :style="{
        width: `${width}px`
      }"
    >
      <div class="qrcode-module">
        <Qrcode :value="qrcode" :options="{ size: 70 }"></Qrcode>
        <div class="tips">
          <div>扫码关注</div>
          <div>了解更多</div>
        </div>
      </div>
      <div v-if="linkList.length" class="link-list">
        友情链接：
        <span class="link-item" v-for="item in linkList" :key="item.label">
          {{ item.label }}
        </span>
      </div>
      <div v-if="navList.length" class="nav-list">
        <div class="nav" v-for="(item, index) in navList" :key="item.title">
          <div v-if="index !== 0" class="separator"></div>
          <div class="nav-module">
            <div class="nav-title">
              <img class="icon" :src="item.icon" alt="" />
              <span>{{ item.title }}</span>
            </div>
            <div class="nav-module-list">
              <div
                class="list-item"
                v-for="nav in item.list"
                :key="nav.label"
                @click="onNavClick(nav)"
              >
                {{ nav.label }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qrcode from "@xkeshi/vue-qrcode";
export default {
  props: {
    height: {
      type: Number,
      default: 200
    },
    qrcode: {
      type: String,
      default: ""
    },
    bgColor: {
      type: String,
      default: "#F5F5F5"
    },
    width: {
      type: Number,
      default: 1200
    },
    linkList: {
      type: Array,
      default: () => []
    },
    navList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Qrcode
  },
  data() {
    return {};
  },
  computed: {
    wrapperStyle() {
      return {
        height: `${this.height}px`,
        background: this.bgColor
      };
    }
  },
  methods: {
    onNavClick(data) {
      this.$emit("click", data);
    }
  }
};
</script>

<style scoped lang="scss">
.nav-module {
  width: 100%;
  text-align: center;
  .inner {
    position: relative;
    display: inline-block;
    height: 100%;
    .link-list {
      text-align: left;
      margin-top: 20px;
      font-size: 12px;
      color: #999;
      .link-item {
        margin-right: 10px;
        cursor: pointer;
      }
    }
    .nav-list {
      margin-top: 20px;
      display: flex;
      .nav {
        display: flex;
        .separator {
          flex: 0 0 0;
          margin: 0 40px;
          width: 100%;
          border-left: 1px solid #d8d8d8;
        }
        &-module {
          .nav-title {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #333;
            font-weight: bold;
            margin-bottom: 10px;
            .icon {
              width: 34px;
              height: 34px;
              margin-right: 12px;
            }
          }
          .nav-module-list {
            text-align: left;
            padding-left: 46px;
            font-size: 12px;
            color: #999;
            .list-item {
              background: transparent;
              border: 0;
              cursor: pointer;
              margin-top: 6px;
            }
          }
        }
      }
    }
    .qrcode-module {
      position: absolute;
      top: 30px;
      right: 0;
      font-size: 12px;
      color: #999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navModule/index.vue